import { allQuests, artists } from "@/mocks/artistData";
import { Link } from "react-router-dom";

const DIFF_COLOR: Record<string, string> = {
  Easy: "#4ade80",
  Medium: "#ffd60a",
  Hard: "#ff6eb4",
};

// Mock: first 6 quests are "my participated" quests
const MY_QUEST_IDS = ["quest-001", "quest-002", "quest-003", "quest-004", "quest-009", "quest-010"];
const MY_STATUS: Record<string, "completed" | "in_progress" | "submitted"> = {
  "quest-001": "completed",
  "quest-002": "completed",
  "quest-003": "completed",
  "quest-004": "submitted",
  "quest-009": "in_progress",
  "quest-010": "in_progress",
};

const STATUS_LABEL: Record<string, { label: string; color: string; icon: string }> = {
  completed: { label: "완료", color: "#4ade80", icon: "ri-check-double-line" },
  submitted: { label: "제출됨", color: "#ffd60a", icon: "ri-time-line" },
  in_progress: { label: "진행 중", color: "#4fc3f7", icon: "ri-loader-4-line" },
};

export default function MyQuests() {
  const myQuests = allQuests.filter((q) => MY_QUEST_IDS.includes(q.id));

  return (
    <div>
      <h3 className="text-white font-bold text-base mb-4 flex items-center gap-2">
        <i className="ri-film-line text-[#4fc3f7]" />
        참여한 캠페인
        <span className="text-white/30 text-sm font-normal">{myQuests.length}개</span>
      </h3>

      <div className="flex flex-col gap-3">
        {myQuests.map((q) => {
          const artist = artists.find((a) => a.id === q.artistId);
          const status = MY_STATUS[q.id];
          const s = STATUS_LABEL[status];
          return (
            <Link
              key={q.id}
              to={`/quests/${q.id}`}
              className="flex items-center gap-4 p-4 rounded-xl border border-white/8 bg-white/[0.02] hover:border-white/15 hover:bg-white/[0.04] transition-all cursor-pointer group"
            >
              {/* Thumbnail */}
              <div className="w-16 h-12 rounded-lg overflow-hidden flex-shrink-0">
                <img src={q.thumbnail} alt={q.title} className="w-full h-full object-cover object-top" />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="text-white text-sm font-semibold truncate">{q.title}</p>
                    <div className="flex items-center gap-2 mt-1 flex-wrap">
                      {artist && (
                        <span className="text-white/40 text-xs flex items-center gap-1">
                          <i className="ri-user-line text-[10px]" />
                          {artist.name}
                        </span>
                      )}
                      <span className="text-xs font-semibold" style={{ color: DIFF_COLOR[q.difficulty] }}>
                        {q.difficulty}
                      </span>
                    </div>
                  </div>
                  <div
                    className="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold flex-shrink-0"
                    style={{ background: `${s.color}15`, color: s.color, border: `1px solid ${s.color}30` }}
                  >
                    <i className={`${s.icon} text-[10px]`} />
                    {s.label}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-star-fill text-[#ffd60a] text-xs" />
                <span className="text-white/60 text-xs font-bold">{q.reward.toLocaleString()}</span>
                <span className="text-white/30 text-[10px]">XP</span>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-4 text-center">
        <Link
          to="/quests"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-white/15 text-white/60 text-sm font-medium hover:border-white/30 hover:text-white transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line" />
          더 많은 캠페인 참여하기
        </Link>
      </div>
    </div>
  );
}
